export default class UploadItem {
        static init(){
		const uploads = document.querySelectorAll('.gf_fileupload');

                if(!uploads) return;
		uploads.forEach(upload => new UploadItem(upload));

	}

	constructor(upload){

                this.upload = upload;

                const fileUpload = this.upload.querySelector('.ginput_container_fileupload');
                const input = fileUpload.querySelector('input[type="file"]');

                input.style.display = 'none';

                input.insertAdjacentHTML('beforebegin', `<label for="${input.id}" tabindex="0" class="button button--upload"><svg class="icon icon-icon_upload"><use xlink:href="#icon-icon_upload"></use></svg><span>Upload your image</span></label>`);

                input.addEventListener('change', (event) => {
		        const file = event.target.files[0];

                        // if there is already a file upload, remove the current with the new upload
                        const currentFileUpload = this.upload.querySelector('.uploaded-field');
                        if (currentFileUpload) { currentFileUpload.remove(); }

                        input.insertAdjacentHTML('afterend',
                        `<div class="uploaded-field" data-removedownload>
                                <span>${file.name}</span>
                                <span>${this.formatBytes(file.size)}</span>
                                <div type="button">
                                <span class="screen-reader-text">Remove file</span>
                                <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg"><path d="M12.803 2.196A7.5 7.5 0 102.197 12.804 7.5 7.5 0 0012.803 2.196zm-2.625 7.2a.536.536 0 010 .783.536.536 0 01-.755 0L7.499 8.255 5.603 10.18a.536.536 0 01-.755 0 .536.536 0 010-.756L6.744 7.5 4.848 5.604a.536.536 0 01.755-.756l1.896 1.897 1.897-1.897a.544.544 0 01.782.756L8.255 7.5l1.923 1.896z" fill="#000" fill-rule="nonzero" opacity=".494"/></svg>
                                </div>
                        </div>`
                        );

                });

                fileUpload.addEventListener('click', (e) => {

                        const fileUploadEl = e.target.closest('[data-removedownload]');
                        const fileUploadInput = e.target.closest('input[type="file"]');

                        if (fileUploadEl) {
                                fileUploadEl.remove();
                        }

                        if(fileUploadInput) {
                                fileUploadInput.value =  '';
                        }
                });
        }

        formatBytes(bytes, decimals = 2) {
                if (bytes === 0) return "0 Bytes";

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

                const i = Math.floor(Math.log(bytes) / Math.log(k));

                return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
        }
}
